export const campaigns = [
  {
    element: '#campaign_welcome',
    popover: {
      title: 'Campaigns',
      description:"Welcome to the Campaigns section! Here, you can easily view and manage all of your school's promotional efforts across various platforms, gaining precise insights into what drives your marketing metrics.",
      position: 'top',
    },
  },
  {
    element: '.filters',
    popover: {
      title: 'Filter Campaigns',
      description: 'Use filters to narrow campaigns by date, platform, status, or program. Ideal for quickly finding relevant campaigns.',
      position: 'left',
    },
  },

  // {
  //   element: '.program_filter',
  //   popover: {
  //     title: 'Program Filter',
  //     description: 'Filter campaigns based on academic programs such as B.E, BCA, MBA, etc. Helps analyze performance program-wise.',
  //     position: 'right',
  //   },
  // },
  //   {
  //   element: '.campaign_filter',
  //   popover: {
  //     title: 'Campaign Filter',
  //     description: 'Quickly narrow down the list by selecting a specific campaign. Useful when you want to focus on a particular promotion or initiative.',
  //     position: 'right',
  //   },
  // },
  //   {
  //   element: '.date_filter',
  //   popover: {
  //     title: 'Date Filter',
  //     description: 'Choose from preset ranges like 30, 60, 90, or 180 days, or set a custom date range to view campaigns from a specific time period.',
  //     position: 'right',
  //   },
  // },
  //  {
  //   element: '.campaign_status_filter',
  //   popover: {
  //     title: 'Status Filter',
  //     description: 'Filter campaigns based on their current status: view all campaigns, only active ones, or those marked as completed.',
  //     position: 'right',
  //   },
  // },
  //   {
  //   element: '.platform_filter',
  //   popover: {
  //     title: 'Platform Filter',
  //     description: 'Filter campaigns based on the platform they were run on — including Google, Facebook, Instagram, Snapchat, and LinkedIn. This helps focus your analysis on specific advertising channels.',
  //     position: 'right',
  //   },
  // },
  {
    element: '.create_campaign_btn',
    popover: {
      title: 'Create Campaign',
      description: 'Initiate a new campaign for a specific program. You can set objectives, budgets, and platforms to advertise on.',
      position: 'right',
    },
  },

// {
//     element: '.campaign_list',
//     popover: {
//       title: 'Campaign List',
//       description: 'Expand any program to view its related campaigns and their performance data.',
//       position: 'top',
//     },
//   },
// {
//   element: '.ads_list',
//   popover: {
//     title: 'Ads List',
//     description: 'View all ads associated with local platform campaigns. Expand a program to explore its linked ad campaigns and analyze their performance.',
//     position: 'top',
//   },
// },
// {
//   element: '.organic_posts_list',
//   popover: {
//     title: 'Organic Posts',
//     description: 'Browse organic posts tied to local platform campaigns. Expand a program to access insights on post engagement and visibility.',
//     position: 'top',
//   },
// },


];
